import { useEffect } from 'react';

import { EVENT_TYPE } from '@~/constants/logger';
import analytics from '@~/modules/analytics';

const useTrackComponentMounted = (component: string) => {
  useEffect(() => {
    analytics.trackEvent(EVENT_TYPE.COMPONENT_MOUNTED, {
      component,
      load_time: window.performance.now(),
      url: window.location.href,
    });
  }, [component]);
};

export default useTrackComponentMounted;
